'use strict';
// Passed sections take over the navigation slot, then return while scrolling up.
(() => {
  const header = document.querySelector('.header');
  const nav = header.querySelector('.desktop-nav');
  const menu = header.querySelector('.menu-button');
  const mobileNav = document.querySelector('#mobile-nav');
  const middle = document.createElement('div');
  middle.className = 'header-middle';
  nav.before(middle);
  middle.append(nav);
  const context = document.createElement('div');
  context.className = 'header-context';
  context.hidden = true;
  middle.append(context);
  const progress = document.createElement('span');
  progress.className = 'header-progress';
  progress.setAttribute('aria-hidden', 'true');
  header.append(progress);

  const steps = [
    ['qualities', '.qualities', '◇'],
    ['discover', '#discover-title', '✧'],
    ['collection', '#collection-title', '◇'],
    ['box', '#box-title', '♡'],
    ['meaning', '#meaning-title', '✧'],
    ['stones', '.stone-story h2', '◇'],
    ['faq', '.faq-section h2', '✧'],
    ['gift', '.final-note > p', '♡']
  ].filter(([,selector])=>document.querySelector(selector)).map(([key, selector, symbol]) => {
    const source = document.querySelector(selector);
    const panel = document.createElement('div');
    panel.className = 'context-panel';
    panel.setAttribute('aria-hidden', 'true');
    if (key === 'qualities') {
      panel.classList.add('context-qualities');
      [...source.children].forEach(child => panel.append(child.cloneNode(true)));
    } else {
      const icon = document.createElement('span');
      icon.className = 'context-symbol';
      icon.textContent = symbol;
      icon.setAttribute('aria-hidden', 'true');
      const title = document.createElement('span');
      title.className = 'context-title';
      source.childNodes.forEach(node => title.append(node.nodeName === 'BR' ? document.createTextNode(' ') : node.cloneNode(true)));
      panel.append(icon, title);
    }
    context.append(panel);
    return {key, source, panel};
  });

  let current = -1;
  let frame = 0;
  header.dataset.contextActive = 'false';
  function show(index) {
    if (index === current) return;
    const active = index >= 0;
    const focusedNav = nav.contains(document.activeElement);
    header.dataset.contextActive = String(active);
    header.dataset.headerStage = active ? steps[index].key : 'home';
    context.hidden = !active;
    nav.hidden = active;
    steps.forEach(({panel}, i) => {
      panel.classList.toggle('is-active', i === index);
      panel.classList.toggle('is-past', i < index);
      panel.setAttribute('aria-hidden', String(i !== index));
    });
    if (active && focusedNav) menu.focus({preventScroll: true});
    if (!active && innerWidth > 900) {
      mobileNav.hidden = true;
      menu.setAttribute('aria-expanded', 'false');
      if (document.activeElement === menu) nav.querySelector('a').focus({preventScroll: true});
    }
    current = index;
  }
  function update() {
    frame = 0;
    const cutoff = header.getBoundingClientRect().bottom + (innerWidth <= 900 ? 40 : 0);
    const bottoms = steps.map(({source}) => source.getBoundingClientRect().bottom);
    const distance = document.documentElement.scrollHeight - innerHeight;
    const fraction = distance > 0 ? Math.min(1, Math.max(0, scrollY / distance)) : 0;
    let next = -1;
    // A small dead band prevents chatter at a section boundary.
    bottoms.forEach((bottom, i) => {
      if (bottom <= cutoff + (i <= current ? 8 : -8)) next = i;
    });
    show(next);
    progress.style.transform = `scaleX(${fraction.toFixed(4)})`;
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  addEventListener('scroll', schedule, {passive: true});
  addEventListener('resize', schedule, {passive: true});
  addEventListener('pageshow', schedule);
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(schedule).observe(document.querySelector('main'));
  if (document.fonts?.ready) document.fonts.ready.then(schedule);
  // Remove the preference from the superseded parallax test.
  try { localStorage.removeItem('diastones-motion-v1'); } catch {}
  schedule();
})();
